import React, { useState } from 'react';
import { Code2, Tent, CheckCircle2, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function TrainingProducts() {
  const [showModal, setShowModal] = useState(false);
  const [showBootcampModal, setShowBootcampModal] = useState(false);
  return <div className="w-full max-w-6xl mx-auto px-4 py-12 md:py-20" data-id="element-206">
      <div className="text-center mb-8 md:mb-12" data-id="element-207">
        <h2 className="text-3xl md:text-5xl font-display font-bold mb-4 text-gray-900" data-id="element-208">
          <span className="text-laravel-red" data-id="element-209">Optional Preparation</span>
          <br data-id="element-210" />
          Training Products
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-211">
        {/* Self-Study Card */}
        <div className="bg-gray-50 hover:bg-white transition-colors border border-cardBorder rounded-3xl p-8 flex flex-col h-full shadow-md" data-id="element-212">
          <div className="w-14 h-14 bg-red-50 rounded-xl flex items-center justify-center mb-6" data-id="element-213">
            <Code2 className="w-8 h-8 text-laravel-red" data-id="element-214" />
          </div>

          <h3 className="text-3xl font-display font-bold mb-4 text-gray-900" data-id="element-215">
            Self-Study <span className="text-laravel-red" data-id="element-216">Training</span>
          </h3>

          <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-217">
            Prepare at your own pace using structured self-study materials
            designed to support exam preparation. Access on-demand lessons,
            coding exercises, and quizzes aligned with:
          </p>

          <ul className="space-y-4 mb-10 flex-grow" data-id="element-218">
            {['Mid-Level Certification', 'Senior Certification', 'Artisan Certification'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-219">
                <CheckCircle2 className="w-5 h-5 text-laravel-red shrink-0" data-id="element-220" />
                <span className="font-medium" data-id="element-221">{item}</span>
              </li>)}
          </ul>

          <button onClick={() => setShowModal(true)} className="w-36 py-3 px-5 border-2 border-laravel-red text-laravel-red hover:bg-laravel-red hover:text-white transition-colors rounded-xl text-sm font-bold" data-id="element-222">
            Learn more
          </button>
        </div>

        {/* Live Bootcamps Card */}
        <div className="bg-gray-50 hover:bg-white transition-colors border border-cardBorder rounded-3xl p-8 flex flex-col h-full shadow-md" data-id="element-223">
          <div className="w-14 h-14 bg-red-50 rounded-xl flex items-center justify-center mb-6" data-id="element-224">
            <Tent className="w-8 h-8 text-laravel-red" data-id="element-225" />
          </div>

          <h3 className="text-3xl font-display font-bold mb-4 text-gray-900" data-id="element-226">
            Live <span className="text-laravel-red" data-id="element-227">Bootcamps</span>
          </h3>

          <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-228">
            Prefer an instructor-led learning experience? Our live bootcamps
            provide focused, hands-on training led by experienced Laravel
            practitioners. Choose from:
          </p>

          <ul className="space-y-4 mb-10 flex-grow" data-id="element-229">
            {['3-Day Mid-Level Bootcamp', '3-Day Senior Bootcamp'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-230">
                  <CheckCircle2 className="w-5 h-5 text-laravel-red shrink-0" data-id="element-231" />
                  <span className="font-medium" data-id="element-232">{item}</span>
                </li>)}
          </ul>

          <button onClick={() => setShowBootcampModal(true)} className="w-36 py-3 px-5 border-2 border-laravel-red text-laravel-red hover:bg-laravel-red hover:text-white transition-colors rounded-xl text-sm font-bold" data-id="element-233">
            Learn more
          </button>
        </div>
      </div>

      {/* Self-Study Training Modal */}
      <AnimatePresence data-id="element-234">
        {showModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShowModal(false)} data-id="element-235">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="bg-white rounded-3xl p-8 md:p-10 max-w-2xl w-full shadow-2xl relative max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-236">
              <button onClick={() => setShowModal(false)} className="absolute top-5 right-5 w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors flex items-center justify-center" data-id="element-237">
                <X className="w-5 h-5 text-gray-600" data-id="element-238" />
              </button>

              <div className="w-14 h-14 bg-red-50 rounded-xl flex items-center justify-center mb-6" data-id="element-239">
                <Code2 className="w-8 h-8 text-laravel-red" data-id="element-240" />
              </div>

              <h3 className="text-3xl font-display font-bold mb-6 text-gray-900" data-id="element-241">
                Self-Study <span className="text-laravel-red" data-id="element-242">Training</span>
              </h3>

              <div className="space-y-4 text-gray-600 leading-relaxed" data-id="element-243">
                <p data-id="element-244">
                  Our self-training material is designed to provide you with the
                  necessary knowledge and skills to prepare for the official
                  certification exam.
                </p>
                <p data-id="element-245">
                  Learn at your own pace and on your own schedule, whenever and
                  wherever is most convenient for you. Whether you're a beginner
                  or an experienced developer, our training material is tailored
                  to help you know the exam material inside and out.
                </p>
                <p data-id="element-246">
                  Our comprehensive training material includes a variety of
                  resources such as interactive exercises, quizzes, and practice
                  exams.
                </p>
                <p data-id="element-247">
                  At the completion of our self-study training program, you will
                  have the knowledge and skills needed to take the official
                  certification exam with confidence. Take the first steps to
                  prove your development potential to employers and clients
                  worldwide now!
                </p>
              </div>

              <button onClick={() => setShowModal(false)} className="mt-8 py-3 px-6 bg-laravel-red text-white hover:bg-red-600 transition-colors rounded-lg text-sm font-bold" data-id="element-248">
                Close
              </button>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Live Bootcamps Modal */}
      <AnimatePresence data-id="element-249">
        {showBootcampModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShowBootcampModal(false)} data-id="element-250">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="bg-white rounded-3xl p-8 md:p-10 max-w-2xl w-full shadow-2xl relative max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-251">
              <button onClick={() => setShowBootcampModal(false)} className="absolute top-5 right-5 w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors flex items-center justify-center" data-id="element-252">
                <X className="w-5 h-5 text-gray-600" data-id="element-253" />
              </button>

              <div className="w-14 h-14 bg-red-50 rounded-xl flex items-center justify-center mb-6" data-id="element-254">
                <Tent className="w-8 h-8 text-laravel-red" data-id="element-255" />
              </div>

              <h3 className="text-3xl font-display font-bold mb-6 text-gray-900" data-id="element-256">
                Live <span className="text-laravel-red" data-id="element-257">Bootcamps</span>
              </h3>

              <div className="space-y-4 text-gray-600 leading-relaxed" data-id="element-258">
                <p data-id="element-259">
                  We offer online bootcamps to supplement preparation for the
                  Mid-level and Senior Laravel Developer certification exams.
                  These sessions are designed to provide focused, practical
                  training.
                </p>

                <div data-id="element-260">
                  <h4 className="text-lg font-display font-bold text-gray-900 mb-2" data-id="element-261">
                    Structure:
                  </h4>
                  <ul className="space-y-2 ml-1" data-id="element-262">
                    <li className="flex items-center gap-3" data-id="element-263">
                      <CheckCircle2 className="w-4 h-4 text-laravel-red shrink-0" data-id="element-264" />
                      <span data-id="element-265">
                        <strong className="text-gray-900" data-id="element-266">Duration:</strong> 3
                        weeks
                      </span>
                    </li>
                    <li className="flex items-center gap-3" data-id="element-267">
                      <CheckCircle2 className="w-4 h-4 text-laravel-red shrink-0" data-id="element-268" />
                      <span data-id="element-269">
                        <strong className="text-gray-900" data-id="element-270">Frequency:</strong> 1
                        day per week
                      </span>
                    </li>
                    <li className="flex items-center gap-3" data-id="element-271">
                      <CheckCircle2 className="w-4 h-4 text-laravel-red shrink-0" data-id="element-272" />
                      <span data-id="element-273">
                        <strong className="text-gray-900" data-id="element-274">
                          Session length:
                        </strong>{' '}
                        5-6 hours per day
                      </span>
                    </li>
                  </ul>
                </div>

                <div data-id="element-275">
                  <h4 className="text-lg font-display font-bold text-gray-900 mb-2" data-id="element-276">
                    Content:
                  </h4>
                  <ul className="space-y-2 ml-1" data-id="element-277">
                    <li className="flex items-center gap-3" data-id="element-278">
                      <CheckCircle2 className="w-4 h-4 text-laravel-red shrink-0" data-id="element-279" />
                      <span data-id="element-280">In-depth coverage of key Laravel concepts</span>
                    </li>
                    <li className="flex items-center gap-3" data-id="element-281">
                      <CheckCircle2 className="w-4 h-4 text-laravel-red shrink-0" data-id="element-282" />
                      <span data-id="element-283">Hands-on exercises to apply learned concepts</span>
                    </li>
                    <li className="flex items-center gap-3" data-id="element-284">
                      <CheckCircle2 className="w-4 h-4 text-laravel-red shrink-0" data-id="element-285" />
                      <span data-id="element-286">
                        Q&A sessions with experienced Laravel developers
                      </span>
                    </li>
                    <li className="flex items-center gap-3" data-id="element-287">
                      <CheckCircle2 className="w-4 h-4 text-laravel-red shrink-0" data-id="element-288" />
                      <span data-id="element-289">
                        Practice exams to familiarize with test format
                      </span>
                    </li>
                  </ul>
                </div>

                <p data-id="element-290">
                  The bootcamps aim to address various skill levels, from
                  developers new to certification to those with more experience.
                  They're available as an optional add-on to the certification
                  exam.
                </p>
              </div>

              <button onClick={() => setShowBootcampModal(false)} className="mt-8 py-3 px-6 bg-laravel-red text-white hover:bg-red-600 transition-colors rounded-lg text-sm font-bold" data-id="element-291">
                Close
              </button>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}